"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsplashSearchResults = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var UnsplashSearchResults = function UnsplashSearchResults(props) {
  (0, _classCallCheck2.default)(this, UnsplashSearchResults);
  (0, _defineProperty2.default)(this, "searchTerm", void 0);
  (0, _defineProperty2.default)(this, "page", void 0);
  (0, _defineProperty2.default)(this, "results", void 0);
  this.searchTerm = props.searchTerm;
  this.page = props.page;
  this.results = props.results;
};

exports.UnsplashSearchResults = UnsplashSearchResults;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2RlbC91bnNwbGFzaC9VbnNwbGFzaFNlYXJjaFJlc3VsdHMudHMiXSwibmFtZXMiOlsiVW5zcGxhc2hTZWFyY2hSZXN1bHRzIiwicHJvcHMiLCJzZWFyY2hUZXJtIiwicGFnZSIsInJlc3VsdHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7SUFRYUEscUIsR0FLVCwrQkFBbUJDLEtBQW5CLEVBQXNEO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFDbEQsT0FBS0MsVUFBTCxHQUFrQkQsS0FBSyxDQUFDQyxVQUF4QjtBQUNBLE9BQUtDLElBQUwsR0FBWUYsS0FBSyxDQUFDRSxJQUFsQjtBQUNBLE9BQUtDLE9BQUwsR0FBZUgsS0FBSyxDQUFDRyxPQUFyQjtBQUNILEMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge1Vuc3BsYXNoSXRlbX0gZnJvbSBcIi4vVW5zcGxhc2hJdGVtXCI7XG5cbmludGVyZmFjZSBVbnNwbGFzaFNlYXJjaFJlc3VsdFBhcmFtcyB7XG4gICAgc2VhcmNoVGVybTogc3RyaW5nO1xuICAgIHBhZ2U6IG51bWJlcjtcbiAgICByZXN1bHRzOiBBcnJheTxVbnNwbGFzaEl0ZW0+O1xufVxuXG5leHBvcnQgY2xhc3MgVW5zcGxhc2hTZWFyY2hSZXN1bHRzIHtcbiAgICBzZWFyY2hUZXJtOiBzdHJpbmc7XG4gICAgcGFnZTogbnVtYmVyO1xuICAgIHJlc3VsdHM6IEFycmF5PFVuc3BsYXNoSXRlbT47XG5cbiAgICBwdWJsaWMgY29uc3RydWN0b3IocHJvcHM6IFVuc3BsYXNoU2VhcmNoUmVzdWx0UGFyYW1zKSB7XG4gICAgICAgIHRoaXMuc2VhcmNoVGVybSA9IHByb3BzLnNlYXJjaFRlcm07XG4gICAgICAgIHRoaXMucGFnZSA9IHByb3BzLnBhZ2U7XG4gICAgICAgIHRoaXMucmVzdWx0cyA9IHByb3BzLnJlc3VsdHM7XG4gICAgfVxufVxuIl19